"use client";
import {fmtTime} from "@/libs/helper";

export const Progressbar: React.FC<any> = ({trips}) => {
  const len = trips?.length ?? 0;
  const colClass =
    len >= 4
      ? "grid-cols-4"
      : len === 3
        ? "grid-cols-3"
        : len === 2
          ? "grid-cols-2"
          : "grid-cols-2";
  return (
    <div className="">
      <div className={`grid ${colClass} gap-2`}>
        {trips.map((trip: any, i: number) => (
          <div key={i} className="overflow-hidden">
            <div
              className={`h-1.5 ${trip.status ? "bg-green-500" : "bg-gray-300"}`}
            />
            <div className="text-[10px] text-gray-500">
              {fmtTime(trip.tripStart)} - {fmtTime(trip.tripEnd)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
